module.exports = __webpack_public_path__ + "static/media/56fba62e-abb5-4929-a6c5-3740c1a83450_1.f3bad0c9b3c4144450e14c36c7c4a563.d6ebeba9.jpeg";